/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteGmsBatch200ResponseAffectedTablesInner
 */
export interface DeleteGmsBatch200ResponseAffectedTablesInner {
    /**
     * 更新したテーブル名
     * @type {string}
     * @memberof DeleteGmsBatch200ResponseAffectedTablesInner
     */
    tableName: string;
    /**
     * 更新件数
     * @type {number}
     * @memberof DeleteGmsBatch200ResponseAffectedTablesInner
     */
    count: number;
}

/**
 * Check if a given object implements the DeleteGmsBatch200ResponseAffectedTablesInner interface.
 */
export function instanceOfDeleteGmsBatch200ResponseAffectedTablesInner(value: object): value is DeleteGmsBatch200ResponseAffectedTablesInner {
    if (!('tableName' in value) || value['tableName'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function DeleteGmsBatch200ResponseAffectedTablesInnerFromJSON(json: any): DeleteGmsBatch200ResponseAffectedTablesInner {
    return DeleteGmsBatch200ResponseAffectedTablesInnerFromJSONTyped(json, false);
}

export function DeleteGmsBatch200ResponseAffectedTablesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteGmsBatch200ResponseAffectedTablesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'tableName': json['table_name'],
        'count': json['count'],
    };
}

export function DeleteGmsBatch200ResponseAffectedTablesInnerToJSON(json: any): DeleteGmsBatch200ResponseAffectedTablesInner {
    return DeleteGmsBatch200ResponseAffectedTablesInnerToJSONTyped(json, false);
}

export function DeleteGmsBatch200ResponseAffectedTablesInnerToJSONTyped(value?: DeleteGmsBatch200ResponseAffectedTablesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'table_name': value['tableName'],
        'count': value['count'],
    };
}

